module.exports = __webpack_public_path__ + "img/jigsaw-back-4.3ea92447.png";